import { render, staticRenderFns } from "./remedy.vue?vue&type=template&id=c512f9a0&scoped=true&"
import script from "./remedy.vue?vue&type=script&lang=js&"
export * from "./remedy.vue?vue&type=script&lang=js&"
import style0 from "./remedy.vue?vue&type=style&index=0&id=c512f9a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c512f9a0",
  null
  
)

export default component.exports